import { SocketStore } from "store/socket";

const useSocket = () => SocketStore.useState(socketState => socketState);

export { useSocket };
